import { useQuery } from '@tanstack/react-query'
import { getUserProfileById } from 'api/user'
import { userProfileByIdKey } from './keys'

export function useUserProfileById(userId?: number | null) {
  return useQuery({
    queryKey: userProfileByIdKey(userId ?? 0),
    queryFn: () => {
      if (userId == null) {
        throw new Error('userId is required')
      }
      return getUserProfileById(userId)
    },
    enabled: userId != null && userId > 0,
    retry: false,
  })
}
